import getFetchOptions from '../utils/getFetchOptions';

import {ENDPOINT_URL} from '../constants';

export default function setAnamneseVersion() {
	return fetch(
		`${ENDPOINT_URL}/getanamnesecustome`,
		getFetchOptions({
			method: 'GET',
		})
	).then((response) => {
		if (!response.ok) {
			throw response;
		}
		return response.json();
	});
}
